export default __webpack_public_path__ + "static/audio-cardio-5-c-bd2eaaac66d1613abb3771ad16d6d250.webp";